import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";

export default function Terms() {
  const { language } = useLanguage();

  const contentEn = (
    <div className="space-y-6 text-sm">
      <p className="text-muted-foreground leading-relaxed">
        <strong>Welcome to Hamarsathi.</strong> This document is an electronic record in terms of the Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
      </p>
      
      <p className="text-muted-foreground leading-relaxed">
        Please read these Terms and Conditions carefully before registering or using the services of Hamarsathi.com. By using or accessing the website, you agree to be bound by these terms. If you do not agree, please do not register or use this platform.
      </p>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">1. Eligibility</h2>
        <p className="text-muted-foreground leading-relaxed">
          To register as a member of Hamarsathi or use this website, you must be of legally marriageable age as per the laws of India (currently 18 years or above for females and 21 years or above for males). 
          This platform is strictly for users seeking matrimonial alliances (marriage) for themselves or on behalf of siblings, children, or relatives. It is not a dating platform, and any usage for dating, hookups, or casual relationships is strictly prohibited.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">2. Registration & Account Security</h2>
        <p className="text-muted-foreground leading-relaxed">
          You agree to provide true, accurate, current, and complete information during registration. You are solely responsible for maintaining the confidentiality of your username and password, and you are fully responsible for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">3. Role of Hamarsathi (Intermediary Platform Disclaimer)</h2>
        <p className="text-muted-foreground leading-relaxed">
          Hamarsathi acts strictly as an online matrimonial classification platform (an intermediary under Section 2(1)(w) of the IT Act, 2000). We do not broker marriages, nor do we guarantee matrimonial alliances or match success. 
        </p>
        <p className="text-muted-foreground leading-relaxed">
          While we implement verification features (such as Selfie Photo Verification and ID checks) to improve safety, <strong>we do not conduct comprehensive background checks</strong> regarding the character, financial status, health, or family background of any user. It is the sole responsibility of the users and their families to conduct complete and independent verification before proceeding with any matrimonial alliance. Hamarsathi shall not be held liable for any misrepresentation, fraud, or emotional/physical distress arising from interactions on the platform.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">4. Premium Membership, Subscriptions & Refunds</h2>
        <p className="text-muted-foreground leading-relaxed">
          Premium services are subject to additional fees as listed on the packages page. All premium subscription plans are activated immediately upon receipt of payment. 
        </p>
        <p className="text-muted-foreground leading-relaxed">
          <strong>Refund Policy:</strong> All payments made for premium plans are strictly non-refundable and non-transferable under any circumstances once the service has been activated. No partial refunds will be provided for unused subscription periods.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">5. User Conduct & Prohibited Content</h2>
        <p className="text-muted-foreground leading-relaxed">
          You agree not to post any objectionable, obscene, offensive, commercial, or illegal content. Harassment, spamming, creating multiple fake profiles, or scraping user data for commercial purposes will result in instant account deactivation, termination, and potential legal action.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">6. Intellectual Property & License</h2>
        <p className="text-muted-foreground leading-relaxed">
          All design, graphics, logo, code, and content on Hamarsathi.com (excluding user-submitted profile info) are the property of Hamarsathi and protected by copyright and intellectual property laws. You may not copy, modify, distribute, or reverse-engineer any part of this platform.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">7. Termination of Account</h2>
        <p className="text-muted-foreground leading-relaxed">
          We reserve the right to suspend, disable, or permanently terminate your account without prior notice or refund if you violate any terms of this agreement, misrepresent facts, or receive multiple valid complaints from other members.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">8. Limitation of Liability</h2>
        <p className="text-muted-foreground leading-relaxed">
          To the maximum extent permitted by law, Hamarsathi, its directors, employees, or partners shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our platform, or from alliances formed through this website.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">9. Jurisdiction & Governing Law</h2>
        <p className="text-muted-foreground leading-relaxed">
          These terms shall be governed by and construed in accordance with the laws of India. Any legal dispute, claim, or proceeding arising under these terms shall be subject to the exclusive jurisdiction of the courts located in <strong>Hazaribagh, Jharkhand, India</strong>.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">10. JharkhandVivah Mitra Program (District Ambassador)</h2>
        <p className="text-muted-foreground leading-relaxed">
          The JharkhandVivah Mitra Program (District Ambassador Program) is an exclusive community ambassador system designed to foster community trust. By enrolling or being appointed as a Vivah Mitra, you agree to the following terms:
        </p>
        <ul className="list-disc pl-5 text-muted-foreground space-y-2 leading-relaxed">
          <li><strong>Eligibility:</strong> Official appointments are made at the sole discretion of the Administration. Only verified accounts with complete profiles are eligible for appointment.</li>
          <li><strong>Monthly Recharge Benefit:</strong> A monthly mobile recharge of ₹299 is guaranteed to appointed Mitras, provided they bring a minimum of 5+ valid referrals (profiles reaching 70%+ completion) in that calendar month.</li>
          <li><strong>Milestone Coupons & Premium Benefits:</strong> Upon reaching the milestone of 10 valid referrals, the Mitra is eligible to receive a ₹200 discount coupon code and 1 Month of Free Premium membership.</li>
          <li><strong>Official Badge & Standing:</strong> Active Mitras will receive the official "District Ambassador" badge on their profile and recognition on the leaderboard. The Administration reserves the right to revoke Mitra status, badges, and benefits at any time for inactive, spam, or fraudulent activities.</li>
        </ul>
      </section>
    </div>
  );

  const contentHi = (
    <div className="space-y-6 text-sm">
      <p className="text-muted-foreground leading-relaxed">
        <strong>हमरसाथी में आपका स्वागत है।</strong> यह दस्तावेज़ सूचना प्रौद्योगिकी अधिनियम, 2000 और उसके तहत लागू नियमों और विभिन्न कानूनों में इलेक्ट्रॉनिक रिकॉर्ड से संबंधित संशोधित प्रावधानों के अनुसार एक इलेक्ट्रॉनिक रिकॉर्ड है। यह इलेक्ट्रॉनिक रिकॉर्ड एक कंप्यूटर सिस्टम द्वारा उत्पन्न किया जाता है और इसके लिए किसी भौतिक या डिजिटल हस्ताक्षर की आवश्यकता नहीं होती है।
      </p>
      
      <p className="text-muted-foreground leading-relaxed">
        हमरसाथी (Hamarsathi.com) की सेवाओं का उपयोग करने या पंजीकरण करने से पहले कृपया इन नियमों और शर्तों को ध्यान से पढ़ें। वेबसाइट का उपयोग करके, आप इन शर्तों से बंधने के लिए सहमत होते हैं। यदि आप सहमत नहीं हैं, तो कृपया पंजीकरण न करें और इस मंच का उपयोग न करें।
      </p>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">1. पात्रता</h2>
        <p className="text-muted-foreground leading-relaxed">
          हमरसाथी के सदस्य के रूप में पंजीकरण करने या इस वेबसाइट का उपयोग करने के लिए, आपको भारत के कानूनों के अनुसार विवाह की कानूनी आयु का होना चाहिए (वर्तमान में महिलाओं के लिए 18 वर्ष या उससे अधिक और पुरुषों के लिए 21 वर्ष या उससे अधिक)। 
          यह मंच केवल उन उपयोगकर्ताओं के लिए है जो अपने या अपने भाई-बहनों, बच्चों या रिश्तेदारों के लिए वैवाहिक गठबंधन (विवाह) की तलाश कर रहे हैं। यह डेटिंग प्लेटफॉर्म नहीं है, और डेटिंग या कैज़ुअल संबंधों के लिए इसका उपयोग सख्त वर्जित है।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">2. पंजीकरण और खाता सुरक्षा</h2>
        <p className="text-muted-foreground leading-relaxed">
          आप पंजीकरण के दौरान सत्य, सटीक और पूर्ण जानकारी प्रदान करने के लिए सहमत हैं। आप अपने उपयोगकर्ता नाम और पासवर्ड की गोपनीयता बनाए रखने के लिए पूरी तरह से ज़िम्मेदार हैं, और आपके खाते के तहत होने वाली सभी गतिविधियों के लिए आप ज़िम्मेदार होंगे।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">3. हमरसाथी की भूमिका (मध्यस्थ मंच अस्वीकरण)</h2>
        <p className="text-muted-foreground leading-relaxed">
          हमरसाथी विशुद्ध रूप से एक ऑनलाइन वैवाहिक वर्गीकरण मंच (सूचना प्रौद्योगिकी अधिनियम, 2000 की धारा 2(1)(w) के तहत एक मध्यस्थ) के रूप में कार्य करता है। हम विवाह नहीं कराते हैं, न ही वैवाहिक गठबंधन या मैच की सफलता की गारंटी देते हैं।
        </p>
        <p className="text-muted-foreground leading-relaxed">
          हालांकि हम सुरक्षा में सुधार के लिए सेल्फी फोटो सत्यापन और आईडी जांच जैसी सुविधाएं लागू करते हैं, <strong>लेकिन हम किसी भी उपयोगकर्ता के चरित्र, वित्तीय स्थिति, स्वास्थ्य या पारिवारिक पृष्ठभूमि की व्यापक जांच नहीं करते हैं।</strong> किसी भी वैवाहिक गठबंधन में आगे बढ़ने से पहले पूरी और स्वतंत्र जांच करना उपयोगकर्ताओं और उनके परिवारों की एकमात्र जिम्मेदारी है। हमरसाथी किसी भी धोखाधड़ी या मानसिक/शारीरिक परेशानी के लिए उत्तरदायी नहीं होगा।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">4. प्रीमियम सदस्यता, सदस्यता शुल्क और रिफंड नीति</h2>
        <p className="text-muted-foreground leading-relaxed">
          प्रीमियम सेवाएं पैकेज पृष्ठ पर सूचीबद्ध अतिरिक्त शुल्कों के अधीन हैं। भुगतान प्राप्त होने पर सभी प्रीमियम सब्सक्रिप्शन तुरंत सक्रिय हो जाते हैं।
        </p>
        <p className="text-muted-foreground leading-relaxed">
          <strong>रिफंड नीति:</strong> सेवा सक्रिय होने के बाद प्रीमियम योजनाओं के लिए किया गया भुगतान किसी भी परिस्थिति में रिफंड (वापस) या ट्रांसफर नहीं किया जाएगा।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">5. उपयोगकर्ता आचरण और प्रतिबंधित सामग्री</h2>
        <p className="text-muted-foreground leading-relaxed">
          आप किसी भी आपत्तिजनक, अश्लील, आक्रामक, व्यावसायिक या अवैध सामग्री को पोस्ट न करने पर सहमत हैं। उत्पीड़न, स्पैमिंग, नकली प्रोफाइल बनाने, या व्यावसायिक उद्देश्यों के लिए उपयोगकर्ता डेटा निकालने के परिणामस्वरूप खाता तुरंत समाप्त कर दिया जाएगा और कानूनी कार्रवाई की जा सकती है।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">6. बौद्धिक संपदा</h2>
        <p className="text-muted-foreground leading-relaxed">
          हमरसाथी.कॉम पर उपलब्ध सभी डिज़ाइन, ग्राफिक्स, लोगो, कोड और सामग्री (उपयोगकर्ता प्रोफाइल को छोड़कर) हमरसाथी की संपत्ति हैं। आप इस मंच के किसी भी हिस्से की नकल, वितरण या रिवर्स-इंजीनियरिंग नहीं कर सकते।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">7. खाता बंद करना</h2>
        <p className="text-muted-foreground leading-relaxed">
          यदि आप शर्तों का उल्लंघन करते हैं या गलत तथ्य पेश करते हैं, तो हम बिना किसी पूर्व सूचना या रिफंड के आपके खाते को निलंबित या स्थायी रूप से बंद करने का अधिकार सुरक्षित रखते हैं।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">8. देयता की सीमा</h2>
        <p className="text-muted-foreground leading-relaxed">
          कानून द्वारा अनुमत अधिकतम सीमा तक, हमरसाथी, उसके निदेशक, कर्मचारी या भागीदार हमारी सेवा का उपयोग करने या न कर पाने के कारण होने वाले किसी भी प्रत्यक्ष या अप्रत्यक्ष नुकसान के लिए उत्तरदायी नहीं होंगे।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">9. अधिकार क्षेत्र और शासी कानून</h2>
        <p className="text-muted-foreground leading-relaxed">
          ये नियम और शर्तें भारत के कानूनों के अनुसार शासित और विश्लेषित होंगी। इन शर्तों के तहत उत्पन्न होने वाले किसी भी कानूनी विवाद या दावे को केवल <strong>हजारीबाग, झारखंड, भारत</strong> में स्थित न्यायालयों के अनन्य अधिकार क्षेत्र के अधीन प्रस्तुत किया जाएगा।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-bold text-primary">10. झारखंडविवाह मित्र कार्यक्रम (जिला राजदूत)</h2>
        <p className="text-muted-foreground leading-relaxed">
          झारखंडविवाह मित्र कार्यक्रम (जिला राजदूत कार्यक्रम) एक विशेष सामुदायिक राजदूत प्रणाली है जिसे सामाजिक विश्वास बढ़ाने के लिए डिज़ाइन किया गया है। विवाह मित्र के रूप में नियुक्त होने पर, आप निम्नलिखित शर्तों से सहमत होते हैं:
        </p>
        <ul className="list-disc pl-5 text-muted-foreground space-y-2 leading-relaxed">
          <li><strong>पात्रता:</strong> आधिकारिक नियुक्तियाँ पूरी तरह से एडमिन के विवेक पर की जाती हैं। केवल पूर्ण प्रोफाइल वाले सत्यापित खाते ही नियुक्ति के लिए पात्र हैं।</li>
          <li><strong>मासिक रिचार्ज लाभ:</strong> नियुक्त मित्रों को ₹299 का मासिक मोबाइल रिचार्ज प्रदान किया जाता है, बशर्ते वे उस कैलेंडर माह में न्यूनतम 5 या उससे अधिक वैध रेफ़रल (70% पूर्ण प्रोफाइल) लाएं।</li>
          <li><strong>माइलस्टोन कूपन और प्रीमियम लाभ:</strong> 10 वैध रेफ़रल के मील के पत्थर तक पहुँचने पर, मित्र ₹200 का डिस्काउंट कूपन कोड और 1 महीने की मुफ्त प्रीमियम सदस्यता प्राप्त करने के प्राप्तकर्ता होंगे।</li>
          <li><strong>आधिकारिक बैज और मान्यता:</strong> सक्रिय मित्रों को उनकी प्रोफाइल पर आधिकारिक "जिला राजदूत" बैज और लीडरबोर्ड पर पहचान दी जाएगी। एडमिन के पास निष्क्रियता, स्पैम या धोखाधड़ी गतिविधियों के लिए किसी भी समय मित्र का दर्जा, बैज और लाभ वापस लेने का अधिकार सुरक्षित है।</li>
        </ul>
      </section>
    </div>
  );

  return (
    <StaticPageLayout
      title={language === "hi" ? "उपयोग की शर्तें" : "Terms of Use"}
      subtitle={language === "hi" ? "कृपया हमारे नियम और शर्तों को समझें" : "Please understand our rules and guidelines"}
    >
      {language === "hi" ? contentHi : contentEn}
    </StaticPageLayout>
  );
}
